<ion-toolbar>
  <ion-buttons slot="start">
    <ion-button
      (click)="onCancel()"
      color="secondary"
      fill="outline"
      >
      <ion-icon name="arrow-back" />
      <span class="hidden-md">&nbsp; {{ 'ACTION.back' | translate }}</span>
    </ion-button>
  </ion-buttons>
  <ion-title id="jobDetailTitle" role="heading" aria-level="2">{{ 'LABEL.waypoint' | translate }}</ion-title>
</ion-toolbar>

<ion-content>

  <route-event-card [data]="data" [preview]="true" [headerLevel]="3" [tapForDetails]="false" />

  <section class="card details">
    <dl>
      <dt>{{ 'LABEL.duration' | translate }}</dt>
      <dd>{{ duration }}</dd>

      @if (job.note) {
        <dt>{{ 'LABEL.notes' | translate }}</dt>
        <dd>{{ job.note }}</dd>
      }
    </dl>
  </section>

</ion-content>

<ion-toolbar class="bottom-actions">
  <ion-button type="button" fill="outline" expand="block" (click)="onCancel()">{{ 'ACTION.close' | translate }}</ion-button>
</ion-toolbar>
